import { FC, useState } from 'react';
import { IconButton, AppBar, Toolbar, useMediaQuery, useTheme, Divider, Typography } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import MenuOpenIcon from '@mui/icons-material/MenuOpen';
import { MobileDropdownMenu } from './MobileDropdownMenu';
import { usePageName } from '../hooks/usePageName';

interface NavbarProps {
    sidebarOpen: boolean;
    onToggleSidebar: () => void;
}

export const Navbar: FC<NavbarProps> = ({ sidebarOpen, onToggleSidebar }) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'), { noSsr: true });
    const [mobileMenuAnchor, setMobileMenuAnchor] = useState<HTMLElement | null>(null);
    const currentPageName = usePageName();

    const handleMobileMenuClick = (event: React.MouseEvent<HTMLElement>) => {
        if (isMobile) {
            setMobileMenuAnchor(event.currentTarget);
        } else {
            onToggleSidebar();
        }
    };

    const handleMobileMenuClose = () => {
        setMobileMenuAnchor(null);
    };

    return (
        <AppBar
            position="static"
            elevation={0}
            sx={{
                backgroundColor: '#FCFCFD',
                borderBottom: '1px solid',
                width: '100%',
            }}
        >
            <Toolbar
                sx={{
                    minHeight: '48px !important',
                    pl: '8px !important',
                    justifyContent: 'flex-start',
                    gap: 1,
                }}
            >
                <IconButton
                    size="medium"
                    onClick={handleMobileMenuClick}
                    sx={{ color: 'text.primary' }}
                >
                    {isMobile ? (
                        <MenuIcon fontSize="inherit" />
                    ) : sidebarOpen ? (
                        <MenuOpenIcon fontSize="inherit" />
                    ) : (
                        <MenuIcon fontSize="inherit" />
                    )}
                </IconButton>

                <Divider
                    orientation="vertical"
                    flexItem
                    sx={{
                        height: '24px',
                        alignSelf: 'center',
                        borderColor: 'divider',
                    }}
                />

                <Typography
                    variant="subtitle1"
                    sx={{
                        color: 'text.primary',
                        fontWeight: 500,
                        fontSize: '0.875rem',
                    }}
                >
                    {currentPageName}
                </Typography>

                <MobileDropdownMenu
                    anchorEl={mobileMenuAnchor}
                    open={Boolean(mobileMenuAnchor)}
                    onClose={handleMobileMenuClose}
                />
            </Toolbar>
        </AppBar>
    );
};
